export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const EDIT_PROFILE = "EDIT_PROFILE"
export const SET_PROFILE_DETAILS = "SET_PROFILE_DETAILS"